import { AppModules } from 'appContainer/types';
import {
  IndexRouteContent,
  PathRouteContent,
  RouteNode,
} from 'router/declarative/routeNode';

export const routes = {
  path: '/use-cases',
  title: 'Solutions',
  appModule: AppModules.USE_CASES,
  children: [
    {
      path: { index: true },
      content: async (): IndexRouteContent =>
        (await import('./UseCaseLandingPage/UseCaseLandingPage'))
          .UseCaseLandingPage,
    },
    {
      path: '/:entityId',
      content: async (): PathRouteContent =>
        (await import('./UseCaseLandingPage/UseCaseLandingPage'))
          .UseCaseLandingPage,
    },
  ],
} as const satisfies RouteNode;
